import { render } from "./Empleados.vue?vue&type=template&id=4842f270&scoped=true"
import script from "./Empleados.vue?vue&type=script&lang=js"
export * from "./Empleados.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4842f270"]])

export default __exports__